import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { SafCasePanel } from "./SafCasePanel";

/** Phase 207 — desktop detail view of one SAF for Supervisors / Municipal Admins (collectors use a full page). */
export function SafCaseDialog({ code, saf, role, open, onClose, onChanged, testIdPrefix = "saf-case" }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-5xl max-h-[92vh] overflow-y-auto" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle className="font-heading text-base">Self-assessment {saf?.saf_id}</DialogTitle>
          <DialogDescription>
            {role === "supervisor"
              ? "Review the Field Collector's verification. You may modify the demand lines before approving, or send the case back with a reason."
              : role === "super_admin"
                ? "Super Admin review. You may approve, send back or reject like the Municipal Admin — or decide a case directly (with a mandatory reason) even while it is still with the Field Collector. Approving generates the Property PIN and links it to the citizen's account."
                : "Final review. Approving generates the Property PIN, creates the property and its demand and links the PIN to the citizen's account. A case still with the Field Collector can be decided directly with a mandatory reason."}
          </DialogDescription>
        </DialogHeader>
        {saf && <SafCasePanel code={code} safId={saf.id} role={role} onDone={onChanged} testIdPrefix={testIdPrefix} />}
      </DialogContent>
    </Dialog>
  );
}
